// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"e074d158","737":"fefadd53","893":"bd4bd152"}[chunkId] + ".chunk.css";
};